import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_s_btn = _resolveComponent("s-btn")!

  return (_openBlock(), _createBlock(_component_s_btn, {
    type: "icon",
    class: _normalizeClass(["s-btn--action s-btn--icon__dark-gray", { 'look-at-me': _ctx.highlight }]),
    icon: "app:settings"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_tooltip, { delay: 1000 }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Настройки таблицы ")
        ])),
        _: 1
      }),
      _renderSlot(_ctx.$slots, "default"),
      _createVNode(_component_q_menu, { class: "s-table__menu--action" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "menu")
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["class"]))
}